module.exports = __webpack_public_path__ + "static/profile-073dec4023b1b8785dd61a4273fc0ddd.png";